import React from 'react';
import { CommonHeader } from '../common/headerUtil';

const ProgramVersions = () => {
  return (
    <>
      <CommonHeader titleText="Program Versions" />
      {/* Your component content goes here */}
      <h1>Program Versions</h1>
    </>
  );
};

export default ProgramVersions;
